import { ADVERT_FORMAT_TYPES } from '@web-platform/shared-universal-constants/src/adverts';

import type {
  ConductorCreativeFlightsInlineCompetitorBrandBannerFields,
  CreativeFlightsInlineBrandBanner,
} from '@web-platform/shared-universal-types/src/redux/acorn/state/flightsDayView/entitiesSearchResults/adverts/types';

export const getCompetitorBrandBannerCreative = (
  fields: ConductorCreativeFlightsInlineCompetitorBrandBannerFields,
): CreativeFlightsInlineBrandBanner => {
  const {
    appIndex,
    callToActionText,
    headline,
    image,
    message,
    partner,
    partnerLogo,
    pioAgencyName,
    pioPartnerName,
    price,
    redirectPageType,
    redirectPlaceCode,
    redirectUrl,
    splitTestId,
  } = fields;

  return {
    appIndex,
    callToActionText,
    headline,
    image,
    message,
    partner,
    partnerLogo,
    redirectPlaceCode,
    format: ADVERT_FORMAT_TYPES.COMPETITOR_BRAND_BANNER,
    redirectUrl,
    price,
    redirectPageType,
    splitTestId,
    pioPartnerName,
    pioAgencyName,
  };
};
